(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rumoe-model-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rumoe-model-picker')) {
  customElements.define('rumoe-model-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-finish-choice]').forEach(choice => {
        choice.setAttribute('role', 'button');
        choice.setAttribute('aria-pressed', String(choice.classList.contains('is-selected')));
      });
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-finish-choice]');
        if (!choice || !this.contains(choice) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        const panels = [...this.querySelectorAll('[data-finish-panel]')];
        const panel = panels.find(item => item.dataset.finishPanel === choice.dataset.finishChoice);
        if (!panel) return;
        event.preventDefault();
        panels.forEach(item => { item.hidden = item !== panel; });
        this.querySelectorAll('[data-finish-choice]').forEach(item => {
          const selected = item === choice;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('[data-finish-choice]')) {
          event.preventDefault();
          event.target.click();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rumoe-watch-waitlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rumoe-watch-waitlist')) {
    customElements.define('rumoe-watch-waitlist', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.email = this.querySelector('input[type="email"]');
        this.button = this.querySelector('button');
        this.message = this.querySelector('[data-waitlist-message]');
        this.label = this.button.textContent;
        this.email.disabled = false;
        this.button.disabled = false;
        this.form.addEventListener('submit', (event) => this.subscribe(event));
      }

      async subscribe(event) {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity()) return;
        this.pending = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.sending;
        this.form.setAttribute('aria-busy', 'true');
        this.message.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.dataset.companyId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-10-15' },
            signal: controller.signal,
            body: JSON.stringify({ data: {
              type: 'back-in-stock-subscription',
              attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: this.email.value.trim() } } } },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.dataset.variantId } } }
            } })
          });
          if (!response.ok) throw new Error('Subscription failed');
          this.form.hidden = true;
          this.querySelector('.wpv__buy-text').hidden = true;
          this.message.className = 'wpv__msg is-success';
          this.message.setAttribute('role', 'status');
          this.message.textContent = this.dataset.success;
        } catch {
          this.message.className = 'wpv__msg is-error';
          this.message.setAttribute('role', 'alert');
          this.message.textContent = this.dataset.error;
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.button.disabled = false;
          this.button.textContent = this.label;
          this.form.removeAttribute('aria-busy');
          this.message.hidden = false;
          this.message.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
